// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginView_wrapper__3XN6P","title":"LoginView_title__2_FDw","btn-login":"LoginView_btn-login__33Zlr"};